import { Pipe, PipeTransform } from '@angular/core';
import { UserOrderInfo } from '@app/core/redux/stores';
import { OrderTriggerType } from '@features/ordering/utilties/enums/order-status.utilities';
import * as moment from 'moment-timezone';
const defaultAsapInterval = 2;
const defaultScheduledInterval = 5;
@Pipe({
  name: 'pickupTimeFormat'
})
export class PickupTimeFormatPipe implements PipeTransform {
  transform(value: string, userOrderInfo: UserOrderInfo): string {
    const momentPickupTime = moment(value);
    let interval: number;
    if(userOrderInfo?.asapPickupTime?.pickupStartTime && userOrderInfo?.asapPickupTime?.pickupStartTime?.local == userOrderInfo?.asapPickupTime?.pickupEndTime?.local) {
      return moment(userOrderInfo?.asapPickupTime?.pickupStartTime?.local).format('h:mm A');
    } else if(userOrderInfo.orderTriggerType === OrderTriggerType.Immediate &&
      userOrderInfo?.asapPickupTime?.pickupStartTime?.local &&
       userOrderInfo?.asapPickupTime?.pickupEndTime?.local) {
        return moment(userOrderInfo?.asapPickupTime?.pickupStartTime?.local).format('h:mm A') + ' - ' + moment(userOrderInfo?.asapPickupTime?.pickupEndTime?.local).format('h:mm A');
   } else if(userOrderInfo.location?.asapDefaultMin > 0 && userOrderInfo.location?.asapDefaultMax > 0) {
      interval = userOrderInfo.location?.asapDefaultMax - userOrderInfo.location?.asapDefaultMin;      
    } else {
      interval = userOrderInfo.orderTriggerType === OrderTriggerType.Immediate ? defaultAsapInterval : defaultScheduledInterval      
    }
    const intervalMinutes = userOrderInfo.orderTriggerType === OrderTriggerType.Immediate ? interval : defaultScheduledInterval;
    return momentPickupTime.format('h:mm A') + ' - ' + momentPickupTime.add(intervalMinutes, 'm').format('h:mm A');
  }
}

